/**
 * Public endpoints that don't require authentication
 * or shouldn't trigger auto-logout on 401 errors
 */
export const PUBLIC_ENDPOINTS = [
  // Authentication endpoints
  '/auth/login',
  '/auth/register',

  // Email verification
  '/auth/verify-email-otp',
  '/auth/resend-email-otp',

  // Password reset
  '/auth/forgot-password',
  '/auth/reset-password',

  // Token refresh
  '/auth/refresh',
] as const;

/**
 * API configuration
 */
export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000',
  TIMEOUT: 30000, // 30 seconds

  // Query cache times
  STALE_TIME: 60 * 1000, // 1 minute
  CACHE_TIME: 5 * 60 * 1000, // 5 minutes

  // Retry configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;
